<style scoped lang="scss">
@import "../mobile";
.wrap-search{
  .order-lists{
    li{
      box-shadow: 0 0 10px rgba(0,0,0,.07);
    }
  }
}
</style>
<template>
  <div class="wrap-app wrap-search bg_gray">
    <qk-search-bar @search="getOrders"/>
    <div class="content">
      <div class="molecular-lists">
        <div class="molecular-item" v-for="item in orderLists" :key="item.id" @click="toDetails(item.id)">
          <div class="top">
            <div>订单号：<span class="text-primary">{{item.code}}</span></div>
            <span class="status" :class="{'status-danger': item.retainGoods}">{{item.retainGoods ? '部分发货' : '全部已发货'}}</span>
          </div>
          <ul class="products">
            <li v-for="itx in item.items" :key="itx.id">
              <img :src="itx.goods.mainImgUrl" class="pro-img">
              <div class="info">
                <div class="title">
                  {{itx.goods.name}}
                  <span class="num">x{{itx.quantity}}</span>
                </div>
                <p class="mt5">货号：{{itx.sku.code}}</p>
                <div class="spec mt5">
                  规格：{{itx.sku.spec}}
                  <span class="fz14 text-primary" v-if="itx.needSendQuantity === 0">发货完成</span>
                  <span class="fz14 text-danger" v-else>剩余数：{{itx.needSendQuantity}}</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="bot">
            共{{item.items.length}}件，应付金额：{{item.amount | amount}}元
            <span>{{item.createTime | rTime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="search-empty" v-show="orderLists.length === 0 && isSearch">
      <img src="@/assets/images/mobile/empty.png">
      <p>没有搜到内容哦~</p>
    </div>
  </div>
</template>

<script>
import { productOrders } from '@/services/api.index'
export default {
  data () {
    return {
      orderLists: [],
      page: 0,
      pageSize: 10,
      isSearch: false,
      fromPath: ''
    }
  },
  created() {
    const orderNo = localStorage.getItem('searchKeywords')
    if (!this.baseMethods.isEmpty(orderNo)) {
      this.getOrders(orderNo)
    }
  },
  methods: {
    getOrders (orderNo) {
      const { page, pageSize } = this
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      productOrders(page, pageSize, orderNo, '', '', '', memberInfo.id).then(res => {
        this.isSearch = true
        this.orderLists = res.data
        localStorage.setItem('searchKeywords', orderNo)
      })
    },
    // 跳转到详情页
    toDetails (id) {
      this.$router.push(`/molecular/order_details?id=${id}`)
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log(from)
    next(vm => {
      vm.fromPath = from.path
      console.log(from.path)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/molecular/search.vue